export const getButtonColor = (selectedLang: string, buttonLang: string) => {
  return selectedLang === buttonLang ? 'var(--color-brand)' : 'black'
}

export const getButtonWeight = (selectedLang: string, buttonLang: string) => {
  return selectedLang === buttonLang ? 'bold' : 'normal'
}
